import { IResponseModel } from './IResponseModel';
import { ApiResponseError } from './ApiResponseError';

export class ApiResponse<T extends IResponseModel> {
    
    statusCode: number;
    values: T;
    errors: ApiResponseError[];
    isSuccess: boolean;

    getPrimaryErrorMessage(): string {
        if (this.errors != null) {
            if (this.errors.length > 0) {
                return this.errors[0].message;
            }
        }

        return null;
    }
}